import React from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import { Suspense } from 'react';

import './assets/css/main.css';
import './assets/css/style.css';
import Nav from './components/nav/nav';
import Home from './components/home/home';
import Footer from './components/footer/footer';

const path = "/tutor";

function App() {
  return (
    <Router>
      <div className="App">
        <Nav />
        <Suspense>
          <Routes>
            <Route path={`${path}/`} element={<Home />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
